import { render, staticRenderFns } from "./instanceUser.vue?vue&type=template&id=704ade85&"
import script from "./instanceUser.vue?vue&type=script&lang=js&"
export * from "./instanceUser.vue?vue&type=script&lang=js&"
import style0 from "./instanceUser.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports